import { createSelector } from 'reselect';
import { RootState } from 'store/types';

export const visitContextSelector = (state: RootState) => state.amwell.visitContext;

export const visitContextDataSelector = createSelector(visitContextSelector, vc => vc.data);
export const visitContextErrorSelector = createSelector(visitContextSelector, vc => vc.errors.data);
export const visitContextLoadingSelector = createSelector(
  visitContextSelector,
  vc => vc.loading.data
);

export const disclaimersAcknowledgedSelector = createSelector(
  visitContextSelector,
  vc => vc.disclaimersAcknowledged
);

export const visitContextActionLoadingSelector = createSelector(
  visitContextSelector,
  vc => vc.loading.action
);
export const visitContextActionErrorSelector = createSelector(
  visitContextSelector,
  vc => vc.errors.action
);
